const React = require("react");
const {
  CookieConsentRootWrapper,
} = require("./src/components/cookie-consent-root-wrapper");

export const wrapPageElement = ({ element }) => (
  <CookieConsentRootWrapper>{element}</CookieConsentRootWrapper>
);
